import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from 'src/app/app.settings';
import { RegisterService } from 'src/app/Services/register.service';
import { EmailVerificationPopupComponent } from '../register/email-verification-popup/email-verification-popup.component';
import * as shajs from 'sha.js';

@Component({
  selector: 'app-student-register',
  templateUrl: './student-register.component.html',
  styleUrls: ['./student-register.component.scss']
})
export class StudentRegisterComponent implements OnInit {

  registerForm: FormGroup;
  public showInfoContent: boolean = false;

  hoi_email: any = "";
  institute_name: any = "";
  address: any = "";
  instituteId: any;
  error: any;
  states: any = [];
  organisations: any = [];
  departments: any = [];
  category: any;
  designations: any = [];
  email: any;

  constructor(
    public dialog: MatDialog,
    private register: RegisterService,
    public appSettings: AppSettings,
    private toastr: ToastrService,
    public fb: FormBuilder,
    public router: Router
  ) {}

  ngOnInit() {
    this.registerForm = this.fb.group({
      name: ["", Validators.compose([Validators.required, Validators.minLength(3)])],
      email: ["", Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$')])],
      mobile: [
        "",
        [Validators.required, Validators.pattern("[56789][0-9]{9}")],
      ],
      sid: [""],
      enrollment_no: ["", Validators.required],
      course: ["", Validators.required],
      admission_date: ["", Validators.required],
      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            "(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$"
          ),
        ]),
      ],
      confirmPassword: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            "(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$"
          ),
        ]),
      ],
    });
  }

  getDetails() {
    this.email = this.registerForm.get("email").value;
    
    let encryptedEmail = btoa(this.registerForm.controls.email.value);
    this.register.getDetails(encryptedEmail).subscribe((response) => this.setData(response));
  }

  setData(data) {
    if (data["type"] == "Error") {
      this.toastr.error(data["message"]);
    }
    if (data["type"] == "Success") {
      this.registerForm.controls.name.setValue(data["details"]["name"]);
      this.registerForm.controls.admission_date.setValue(
        data["details"]["date_of_addmission"]
      );
      this.registerForm.controls.enrollment_no.setValue(
        data["details"]["enrollment_number"]
      );
      this.registerForm.controls.mobile.setValue(data["details"]["mobile"]);
      this.registerForm.controls.sid.setValue(data["details"]["student_id"]);
      this.registerForm.controls.course.setValue(data["details"]["course"]);
    }
  }

  //  SHA 512 encryption and submission of form
  onSubmit(values) {
    if (this.registerForm.valid) {
      if (values.password == values.confirmPassword) {
        let tempEmail = this.registerForm.controls.email.value;
        let lowerCaseEmail = tempEmail.toLowerCase();
        let encryptedEmail = btoa(lowerCaseEmail);
        // let encryptedEmail = btoa(this.registerForm.controls.email.value);
        let encryptedPassword = shajs('sha512').update(this.registerForm.controls.password.value + encryptedEmail).digest('hex');

        values['password'] = encryptedPassword;
        values['confirmPassword'] = shajs('sha512').update(this.registerForm.controls.confirmPassword.value + encryptedEmail).digest('hex');;
        values['email'] = encryptedEmail;
        
        this.register.SubmitStudentRegistration(values).subscribe(
          (response) => this.handleResponse(response),
          (error) =>  this.toastr.error(error.error.errors)
        );
      } else {
        this.toastr.error("Password confirmation does not match!");
      }
    } else {
      this.toastr.error("Kindly fill all the details");
    }
  }

  handleResponse(data) {
    if (data["type"] == "Success") {
      this.toastr.success("Registered Successfully!");
      this.verifyEmailPopup();
    } else {
      this.toastr.error(data["message"]);
    }
  }

  verifyEmailPopup() {
    const dialogRef = this.dialog.open(EmailVerificationPopupComponent);
    dialogRef.afterClosed().subscribe(() => {
      this.ngOnInit();
    });
  }

  isSpace(evt) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode == 32) {
      return false;
    }
    return true;
  }
}